import { render } from "./address.vue?vue&type=template&id=5ea291ce&class=bg-gray-bgcolor%20font-nunito"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"

import "./address.vue?vue&type=style&index=0&id=5ea291ce&lang=css"
script.render = render

export default script